import { Routes, Route } from "react-router-dom";
import "./App.css";
import { ThemeProvider } from "./components/ThemeContext";
import Home from "./pages/Home";
import LoginPage from "./components/LoginPage";
import Table from "./components/Table";
import DetailClassSize from "./pages/DetailClassSize";
import DetailAttendance from "./pages/DetailAttendance";
import DetialPassingRate from "./pages/DetailPassingRate";
import DetailNewEnrol from "./pages/DetailNewEnrol";
import DetailReEnrol from "./pages/DetailReEnrol";
import DetailClassStatus from "./pages/DetialClassStatus";
import DetailQualityOfPasses from "./pages/DetailQualityOfPasses";
import DetailStudentEvaluation from "./pages/DetailStudentEvalutation";

function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/table" element={<Table/>} />
        <Route path="/detailclass" element={<DetailClassSize/>} />
        <Route path="/detailattendance" element={<DetailAttendance />}/>
        <Route path="/detailpassingrate" element={<DetialPassingRate />} />
        <Route path="/detailnewenrol" element={<DetailNewEnrol />} />
        <Route path="/detailreenrol" element={<DetailReEnrol />} />
        <Route path="/detailclassstatus" element={<DetailClassStatus />} />
        <Route path="/detailqualityofpasses" element={<DetailQualityOfPasses />} />
        <Route path="/detailstudentevaluation" element={<DetailStudentEvaluation />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
